import track from './trackingHoC';

export { default as deepmerge } from 'deepmerge';

export { default as withTracking } from './withTrackingComponentDecorator';
export { default as trackEvent } from './trackEventMethodDecorator';
export { default as TrackingPropType } from './TrackingPropType';
export { default as useTracking } from './useTracking';

export { track, track as default };
